import { Avatar } from '@material-ui/core';
import { isLoggedIn } from 'api/UserApi';
import React from 'react';
import { IGroupMember } from '../models';

export default function MemberAvatar({ member, classes }: { member: IGroupMember; classes: string }) {
    return member.image?.image ? (
        <Avatar
            alt={member.first_name}
            src={member.image.image}
            className={classes}
            style={{ filter: isLoggedIn() ? '' : 'blur(3px)' }}
        />
    ) : (
        <Avatar alt={member.first_name} className={classes} style={{ filter: isLoggedIn() ? '' : 'blur(3px)' }}>
            {`${member.first_name[0]}${member.last_initial}`}
        </Avatar>
    );
}
